import { render, staticRenderFns } from "./globalMenuGroupsSelectorDialog.vue?vue&type=template&id=18adff20"
import script from "./globalMenuGroupsSelectorDialog.vue?vue&type=script&lang=js"
export * from "./globalMenuGroupsSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./globalMenuGroupsSelectorDialog.vue?vue&type=style&index=0&id=18adff20&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18adff20')) {
      api.createRecord('18adff20', component.options)
    } else {
      api.reload('18adff20', component.options)
    }
    module.hot.accept("./globalMenuGroupsSelectorDialog.vue?vue&type=template&id=18adff20", function () {
      api.rerender('18adff20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/centricOS-global-menu-group-permissions/globalMenuGroupsSelectorDialog.vue"
export default component.exports